module.exports = __webpack_public_path__ + "img/safeway.ce27ce41.jpg";